import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { Experiments } from '@wix/thunderbolt-symbols'
import { ExperimentsSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from '../symbols'
import type { ITpaWorker, TpaWorkerSiteConfig } from '@wix/thunderbolt-types'
import { isTpaWorker, getWorkerAppDefId, getWorkerApplicationId } from '../tpaWorkerCommon'

export const TpaWorkerFactoryDs = withDependencies(
	[named(SiteFeatureConfigSymbol, name), ExperimentsSymbol],
	({ tpaWorkers }: TpaWorkerSiteConfig, experiments: Experiments): ITpaWorker => {
		const deprecateAppIdExperimentOn = experiments['specs.thunderbolt.deprecateAppId']
		return {
			getWorkerDetails(compId) {
				if (deprecateAppIdExperimentOn) {
					const appDefinitionId: string = getWorkerAppDefId(compId)!
					return { ...tpaWorkers[appDefinitionId!], appDefinitionId }
				} else {
					const applicationId = getWorkerApplicationId(compId)
					return tpaWorkers[applicationId!]
				}
			},
			isTpaWorker,
		}
	}
)
